/** Пункт «Сезонный набор» — сразу после каталога в шапке */
export const siteCsaNavLink = {
  href: '/csa',
  label: 'Сезонный набор',
} as const

/** Пункты блока «Информация» в шапке и подвале сайта */
export const siteInfoNavLinks = [
  { href: '/about', label: 'О нас' },
  { href: '/delivery', label: 'Доставка' },
  { href: '/payment', label: 'Оплата' },
  { href: '/contacts', label: 'Контакты' },
] as const
